<!-- eslint-disable vue/multi-word-component-names -->

<template>
  <div class="row q-col-gutter-md">
    <div class="col-12 col-md-6">
      <GlassCard class="q-pa-xs">
        <CampusPlusLogo size="64" style="float: right; margin-right: -10px; margin-left: 10px; margin-top: -10px" />
        <h1 class="q-mb-md">{{ $t("portal.start.welcome.heading") }}</h1>
        <p class="q-mb-sm">
          {{ $t("portal.start.welcome.body") }}
        </p>

        <div class="q-mt-lg q-mb-none">
          <h5>{{ $t("portal.start.labels.newsletter") }}:</h5>
          <i18n-t keypath="portal.start.newsletter.body" tag="p" scope="global"
            ><a href="https://www.lists.kit.edu/sympa/subscribe/campusplus">{{ $t("portal.start.newsletter.name") }}</a></i18n-t
          >
        </div>

        <q-btn :icon="symOutlinedImportContacts" size="md" no-caps color="blue" class="q-mb-md" :to="{ name: 'SMUProceduresList' }"
          >&nbsp;{{ $t("portal.gotosignmeup") }}</q-btn
        >

        <p v-if="!isLoggedIn">
          {{ $t("portal.start.login.requiredText") }}<br />
          <q-btn
            color="teal"
            href="/api/user/oidc-login"
            class="q-mt-sm q-mr-sm"
            :icon="symOutlinedLogin"
            :label="t('portal.start.login.loginKIT')"
          ></q-btn>
          <q-btn
            color="purple"
            :to="{ name: 'Login' }"
            class="q-mt-sm q-mr-sm"
            :icon="symOutlinedLogin"
            :label="t('portal.start.login.loginExternal')"
          ></q-btn>
          <q-btn
            color="indigo"
            :to="{ name: 'Register' }"
            class="q-mt-sm"
            :icon="symOutlinedAppRegistration"
            :label="t('portal.start.login.register')"
          ></q-btn>
        </p>
      </GlassCard>
    </div>
    <div class="col-12 col-md-6">
      <GlassCard class="q-pa-xs">
        <h2 class="q-mb-sm">{{ $t("common.labels.changes") }}</h2>

        <h5>Version 2.31: SignMeUp: Vorschau und Blättern für Verwaltungsansicht</h5>
        <div class="text-caption text-bold" style="--color-highlight-2: #ff0000">29.08.2025</div>
        <p>
          Ab sofort steht die Detailvorschau auch in der Verwaltungsansicht zur Verfügung. Beim Klick auf ein Verfahren öffnet sich rechts
          eine Seitenleiste, in der Sie alle Informationen einsehen können – auch für private oder unveröffentlichte Verfahren. Damit sparen
          Sie zusätzliche Seitenwechsel und behalten selbst bei internen Angeboten den vollständigen Überblick. Zu der Detailseite gelangen
          Sie weiterhin über einen Klick auf den Titel des Verfahrens.<br /><br />
          Innerhalb der Detailseiten können Sie ausserdem mit den neuen Buttons zum vorherigen oder nächsten Verfahren in der Liste
          navigieren. So können Sie schnell zwischen den einzelnen Verfahren wechseln, ohne zur Liste zurückkehren zu müssen.
        </p>

        <h5>Version 2.30: SignMeUp: Verbesserungen beim Nachrichtenversand und der Gebührenverwaltung</h5>
        <div class="text-caption text-bold" style="--color-highlight-2: #ff0000">24.07.2025</div>
        <p>
          Diese Version bringt viele neue Funktionen für SignMeUp. So können Sie nun Nachrichten über mehrere Verfahren hinweg versenden
          sowie individuelle E-Mail-Adressen zur Empfängerliste hinzufügen. Außerdem wurde die Gebührenverwaltung um eine Gebührenübersicht
          erweitert, der Gebührenstatus in der Teilnehmersuche hinzugefügt und eine Gebührenerinnerung eingebaut. Außerdem bietet der ILIAS
          Export die Möglichkeit nur Teilnehmer zu exportieren, die eine Gebühr bezahlt haben.
        </p>

        <h5>Version 2.23: SignMeUp: Eigene Anzeigetexte und Nachträgliche Änderung der Terminwahl</h5>
        <div class="text-caption text-bold" style="--color-highlight-2: #ff0000">01.07.2025</div>
        <p>
          Mit diesem Update gibt es eine neue Möglichkeit, eigene Texte zu hinterlegen. Sie können nun in den Einstellungen unter Weitere
          Angaben einen Text definieren, welcher nach einer erfolgreichen Anmeldung angezeigt wird. Dieser erscheint im
          Anmeldebestätigungsdialog. Hier können Sie z.B. Links auf weitere Anmeldeverfahren oder Hinweise hinterlegen. Dieser Text wird
          immer angezeigt und ist nicht statusabhängig. In der Regel ist es sinnvoll den Text auch in den E-Mail-Benachrichtigungen
          zusätzlich einzufügen.
          <br /><br />
          Neu ist außerdem die Möglichkeit über den neuen Parameter "Nachträgliche Änderung der Themenwahl zulassen" in den Einstellungen
          zuzulassen, dass angemeldete Personen ihre Themen- oder Terminwahl nachträglich ändern können. Bisher war dazu eine Abmeldung und
          Neuanmeldung notwendig. Der Wechsel ist nur auf Termine und Themen mit freien Plätzen möglich. Dies kann z.B. auch für
          Sprechstunden hilfreich sein.
        </p>

        <p class="q-mt-sm">
          {{ $t("portal.start.changes.allchangestext") }}
          <a href=" https://docs.campus.kit.edu/updates/" target="_blank" class="text-blue text-bold">{{
            $t("portal.start.changes.versinfo")
          }}</a
          >.
        </p>
      </GlassCard>
    </div>
    <!-- <div>
        <q-btn class=" q-ma-xs" color="primary">Primary</q-btn>
              <q-btn class="q-ma-xs" color="secondary">secondary</q-btn>
              <q-btn class="q-ma-xs" color="accent">accent</q-btn>
              <q-btn class="q-ma-xs" color="positive">positive</q-btn>
              <q-btn class="q-ma-xs" color="negative">negative</q-btn>
              <q-btn class="q-ma-xs" color="info">info</q-btn>
              <q-btn class="q-ma-xs" color="warning">warning</q-btn>
              <q-btn class="q-ma-xs" color="main">main</q-btn>
              <q-btn class="q-ma-xs" color="content">content</q-btn>
              <q-btn class="q-ma-xs" color="content-2">content-2</q-btn><br />
              <q-btn class="q-ma-xs" color="pantone-illuminating">pantone-illuminating</q-btn>
              <q-btn class="q-ma-xs" color="pantone-illuminating-complementary">pantone-illuminating-c</q-btn>
              <q-btn class="q-ma-xs" color="pantone-classic-blue">pantone-classic-blue</q-btn>
              <q-btn class="q-ma-xs" color="pantone-classic-blue-complementary">pantone-classic-blue-c</q-btn>
              <q-btn class="q-ma-xs" color="pantone-kingfisher-blue">pantone-kingfisher-blue</q-btn>
              <q-btn class="q-ma-xs" color="pantone-kingfisher-blue-complementary">pantone-kingfisher-blue-c</q-btn>
              <q-btn class="q-ma-xs" color="pantone-very-peri">pantone-very-peri</q-btn>
              <q-btn class="q-ma-xs" color="campus-yellow">campus-yellow</q-btn>
      </div> -->
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import CampusPlusLogo from "@/components/shared/CampusPlusLogo.vue";
import useUserProfile from "@/composables/useUserProfile";
import {
  symOutlinedAppRegistration,
  symOutlinedImportContacts,
  symOutlinedList,
  symOutlinedLogin,
} from "@quasar/extras/material-symbols-outlined";
import { useTitle } from "@vueuse/core";

import GlassCard from "../components/shared/GlassCard.vue";
import MiniCard from "../components/shared/MiniCard.vue";
import MiniGlassCard from "@/components/shared/MiniGlassCard.vue";

const { t } = useI18n();
const { isLoggedIn } = useUserProfile();

useTitle(computed(() => "Campus Plus Portal - " + t("portal.start.welcome.label")));
</script>
